/* eslint-disable */
module.exports = function Logger(prefix, debug) {
  var slice = Array.prototype.slice;
  prefix = [prefix];
  debug = debug || true;

  function log() {
    debug && console.info.apply(null, prefix.concat(slice.call(arguments)));
  }
  log.warn = function() {
    console.warn.apply(null, prefix.concat(slice.call(arguments)));
  };

  return log;
}
